<div class="container">
  <div class="pt-2">
    <h1 class="page-title">My Member Assistance Dashboard</h1>
  </div>
  <div class="hover-red">
    <a tabindex="0" class="hover-red btn btn-link" (click)="onPrevious()">
      <svg xmlns="http://www.w3.org/2000/svg" width="16.875" height="15.75" viewBox="0 0 16.875 15.75">
        <g id="_icons_arrow-back-outline" data-name="⚛️ icons/arrow-back-outline" transform="translate(0)">
          <path id="Combined_Shape" data-name="Combined Shape"
            d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
            transform="translate(0)" fill="#174a7c" />
        </g>
      </svg>
      <span class="ps-2">Back to TennCare Access Welcome Page</span>
    </a>
  </div>
  <br />
  <div class="container">
    <div class="card" style="width: 100%">
      <div class="card-body">
        <h2 class="section-header">My Member Assistance Dashboard</h2>
        <hr />
        <p>
          Review the list of members you added to your Member Assistance
          Dashboard. To add additional members, click <b>Add Another Member.</b>
        </p>
        <br />
        <p>
          The information in the <b>My Added Members</b> table below is updated
          daily.
        </p>

        <!-- Accordion Box on the left -->
        <div class="row mt-3">
          <div class="col-lg-12">
            <div class="accordion-box">
              <div id="accordion">
                <!-- Accordion Content -->
                <div id="heading_1">
                  <div class="row">
                    <div class="col-12 d-flex align-items-center">
                      <p id="headerButton_1" aria-hidden="true" style="margin-bottom: unset">
                        <span><img [src]="'assets/images/Icons/tool-tip-icon.svg'" alt="" /></span>
                        <span style="
                            font: normal normal bold 18px 'Open Sans' !important;
                          "><strong>
                            More Information about the My Member Assistance
                            Dashboard</strong></span>
                      </p>
                      <span class="visually-hidden" aria-hidden="false">
                        {{ "INFORMATION_tooltip" | translate }} What displays on
                        the My Member Assistance Dashboard?
                      </span>
                      <div id="caratId_1" class="carat ms-auto" data-bs-toggle="collapse" data-bs-target="#collapse_1"
                        aria-controls="collapse_1">
                        <span id="dwn_1" class="cla2"><mat-icon>expand_more</mat-icon></span>
                        <span id="up_1" class="cla1"><mat-icon>expand_less</mat-icon></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="collapse_1" class="collapse show" aria-labelledby="heading_1" data-bs-parent="#accordion">
                  <div class="card-body d-none d-lg-block">
                    <p>
                      The <b>Member Search</b> screen allows you to search and
                      add members to <b>My Added Members</b>. You can only add
                      members who were on the most recent Additional Information
                      (AI) Report your organization received. Members you have
                      added to your dashboard will display below with the
                      <b>Action </b>needed. The members you have added will
                      display on your dashboard until their coverage has ended
                      or until you remove them.​
                    </p>
                    <br />
                    <p>
                      Member Assistance Dashboard information will be updated
                      daily. The <b>Last Action</b> date is updated once the
                      action is taken and the screen is refreshed.
                    </p>
                    @if(this.ltssDashboardSwitch) {
                    <br />
                    <p>
                      A red dot next to a member's name means they have had a new action on their case since the last
                      time you logged in.
                    </p>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8"></div>
        </div>
        <br />

        <div class="dataBox">

          <!-- if ltssDashboardSwitch is true, display sort/filter/export and header -->
          @if(this.ltssDashboardSwitch) {
          <div class="d-flex header-display">

            <div class="section-header members-added">
              My Added Members ({{ this.totalResults.length }})
            </div>

            <div class="col d-flex sort-display justify-content-end align-items-start filter-sort-export">
              <!-- Sort / Filter dropdown panel -->
              <div class="dropdown sort-filter-dropdown" [class.sf-open-up]="sortFilterOpenUp"
                [class.sf-open-down]="!sortFilterOpenUp">
                <button class="sort-by-toggle dropdown-toggle w-100 text-start" type="button" id="sortFilterDropdown"
                  data-bs-toggle="dropdown" data-bs-auto-close="outside" data-bs-boundary="viewport"
                  (mousedown)="setSortFilterDirection()" (touchstart)="setSortFilterDirection()"
                  aria-expanded="false">
                  Sort/Filter:
                </button>
                <div class="dropdown-menu sort-filter-menu" aria-labelledby="sortFilterDropdown">

                  <!-- Sort section -->
                  <div class="sf-section-label">Sort</div>
                  <button class="sf-sort-item" [class.sf-sort-item--active]="selectedSort === 'Due Date - New to Old'"
                    type="button" (click)="onSortChange('Due Date - New to Old')">
                    <span>Due Date - New to Old</span>
                    <mat-icon class="sf-check"
                      [class.sf-check--visible]="selectedSort === 'Due Date - New to Old'">check</mat-icon>
                  </button>
                  <button class="sf-sort-item" [class.sf-sort-item--active]="selectedSort === 'Due Date - Old to New'"
                    type="button" (click)="onSortChange('Due Date - Old to New')">
                    <span>Due Date - Old to New</span>
                    <mat-icon class="sf-check"
                      [class.sf-check--visible]="selectedSort === 'Due Date - Old to New'">check</mat-icon>
                  </button>
                  <button class="sf-sort-item"
                    [class.sf-sort-item--active]="selectedSort === 'Latest Notice - New to Old'" type="button"
                    (click)="onSortChange('Latest Notice - New to Old')">
                    <span>Latest Notice - New to Old</span>
                    <mat-icon class="sf-check"
                      [class.sf-check--visible]="selectedSort === 'Latest Notice - New to Old'">check</mat-icon>
                  </button>
                  <button class="sf-sort-item"
                    [class.sf-sort-item--active]="selectedSort === 'Latest Notice - Old to New'" type="button"
                    (click)="onSortChange('Latest Notice - Old to New')">
                    <span>Latest Notice - Old to New</span>
                    <mat-icon class="sf-check"
                      [class.sf-check--visible]="selectedSort === 'Latest Notice - Old to New'">check</mat-icon>
                  </button>

                  <!-- Filter section -->
                  <span class="sf-section-label--border clear">
                    <div class="sf-section-label">Filter</div>
                    <button class="sf-section-label clear-filters-btn" type="button" (click)="clearFilters()">
                      Clear Filters
                    </button>
                  </span>

                  <div class="sf-subsection-label">Action Needed</div>
                  <div class="sf-filter-row">
                    <label id="filterActionAILabel" for="filterActionAI">Upload Documents</label>
                    <input id="filterActionAI" type="checkbox" class="sf-status-checkbox"
                      aria-labelledby="filterActionAILabel"
                      [formControl]="filterActionAI"
                      (keydown.enter)="toggleCheckbox(filterActionAI); $event.preventDefault()"
                      (keydown.space)="toggleCheckbox(filterActionAI); $event.preventDefault()" />
                  </div>
                  <div class="sf-filter-row">
                    <label id="filterActionPRLabel" for="filterActionPR">Complete Renewal</label>
                    <input id="filterActionPR" type="checkbox" class="sf-status-checkbox"
                      aria-labelledby="filterActionPRLabel"
                      [formControl]="filterActionPR"
                      (keydown.enter)="toggleCheckbox(filterActionPR); $event.preventDefault()"
                      (keydown.space)="toggleCheckbox(filterActionPR); $event.preventDefault()" />
                  </div>
                  <div class="sf-filter-row">
                    <label id="filterActionPTLabel" for="filterActionPT">Complete Questions for Review</label>
                    <input id="filterActionPT" type="checkbox" class="sf-status-checkbox"
                      aria-labelledby="filterActionPTLabel"
                      [formControl]="filterActionPT"
                      (keydown.enter)="toggleCheckbox(filterActionPT); $event.preventDefault()"
                      (keydown.space)="toggleCheckbox(filterActionPT); $event.preventDefault()" />
                  </div>
                  <div class="sf-filter-row">
                    <label id="filterActionTCLabel" for="filterActionTC">View TennCare Connect</label>
                    <input id="filterActionTC" type="checkbox" class="sf-status-checkbox"
                      aria-labelledby="filterActionTCLabel"
                      [formControl]="filterActionTC"
                      (keydown.enter)="toggleCheckbox(filterActionTC); $event.preventDefault()"
                      (keydown.space)="toggleCheckbox(filterActionTC); $event.preventDefault()" />
                  </div>

                  <div class="sf-subsection-label case-status">Case Status</div>
                  <div class="sf-status-row">
                    <label for="filterStatusApproved" class="sf-status-label">
                      <span class="badge badge-approved">Approved</span>
                    </label>
                    <input id="filterStatusApproved" type="checkbox" class="sf-status-checkbox"
                      [formControl]="filterStatusApproved" tabindex="0"
                      (keydown.enter)="toggleCheckbox(filterStatusApproved); $event.preventDefault()"
                      (keydown.space)="toggleCheckbox(filterStatusApproved); $event.preventDefault()" />
                  </div>
                  <div class="sf-status-row">
                    <label for="filterStatusPending" class="sf-status-label">
                      <span class="badge badge-pending">Pending</span>
                    </label>
                    <input id="filterStatusPending" type="checkbox" class="sf-status-checkbox"
                      [formControl]="filterStatusPending" tabindex="0"
                      (keydown.enter)="toggleCheckbox(filterStatusPending); $event.preventDefault()"
                      (keydown.space)="toggleCheckbox(filterStatusPending); $event.preventDefault()" />
                  </div>
                  <div class="sf-status-row">
                    <label for="filterStatusTerminated" class="sf-status-label">
                      <span class="badge badge-terminated">Terminated</span>
                    </label>
                    <input id="filterStatusTerminated" type="checkbox" class="sf-status-checkbox"
                      [formControl]="filterStatusTerminated" tabindex="0"
                      (keydown.enter)="toggleCheckbox(filterStatusTerminated); $event.preventDefault()"
                      (keydown.space)="toggleCheckbox(filterStatusTerminated); $event.preventDefault()" />
                  </div>

                </div>
              </div>
              <span tabindex="0" (click)="exportExcel()" style="text-align: right; cursor: pointer;">
                <svg xmlns="http://www.w3.org/2000/svg" width="22.333" height="30.633" viewBox="0 0 26.333 33.633">
                  <g id="Group_1571" data-name="Group 1571" transform="translate(-12719 -2391)">
                    <path id="Path_821" data-name="Path 821"
                      d="M114.25,176h3.042a3.042,3.042,0,0,1,3.042,3.042v15.816a3.042,3.042,0,0,1-3.042,3.042H99.042A3.042,3.042,0,0,1,96,194.858V179.042A3.042,3.042,0,0,1,99.042,176h3.042"
                      transform="translate(12624 2225.733)" fill="none" stroke="#174a7c" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="2" />
                    <path id="Path_822" data-name="Path 822" d="M176,65.033l6.083,6.083,6.083-6.083M182.083,48V69.9"
                      transform="translate(12550.083 2344)" fill="none" stroke="#174a7c" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="2" />
                  </g>
                </svg>
              </span>
            </div>

            <br />
          </div>
          }

          <!-- if ltssDashboardSwitch is false, display just export -->
          @if(!this.ltssDashboardSwitch) {
          <div class="row">
            <h6 class="col-11 section-header" style="text-align: center; margin-top: 20px; padding-left: 100px">
              My Added Members ({{ this.totalResults.length }})
            </h6>
            <span class="col" tabindex="0" (click)="exportExcel()" style="
                          text-align: right;
                          cursor: pointer;
                          margin-top: 20px;
                          margin-right: 20px;
                        ">
              <svg xmlns="http://www.w3.org/2000/svg" width="22.333" height="30.633" viewBox="0 0 26.333 33.633">
                <g id="Group_1571" data-name="Group 1571" transform="translate(-12719 -2391)">
                  <path id="Path_821" data-name="Path 821"
                    d="M114.25,176h3.042a3.042,3.042,0,0,1,3.042,3.042v15.816a3.042,3.042,0,0,1-3.042,3.042H99.042A3.042,3.042,0,0,1,96,194.858V179.042A3.042,3.042,0,0,1,99.042,176h3.042"
                    transform="translate(12624 2225.733)" fill="none" stroke="#174a7c" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="2" />
                  <path id="Path_822" data-name="Path 822" d="M176,65.033l6.083,6.083,6.083-6.083M182.083,48V69.9"
                    transform="translate(12550.083 2344)" fill="none" stroke="#174a7c" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="2" />
                </g>
              </svg>
            </span>
            <br />
          </div>
          }

          <!-- Added members table code -->
          <hr style="margin-left: 2px !important; margin-right: 2px !important" />
          <div style="margin: 20px" class="datatable-scroll-wrapper" #datatableWrapper>
            <br />
            <div class="table-container mat-elevation-z8" tabindex="0" role="region" aria-label="Member data table">
              <table class="table w-100 table-striped" mat-table [dataSource]="dataSource">
                @if(this.ltssDashboardSwitch) {
                <ng-container matColumnDef="showDot" sticky>
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="35">
                      <span class="visually-hidden">New action status</span>
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="35" [style.padding]="'0'"
                    [style.textAlign]="'center'">
                    @if (element.showDot) {
                      <span class="member-dot" aria-hidden="true"></span>
                      <span class="visually-hidden">New action on this case</span>
                    }
                  </td>
                </ng-container>
                }

                <ng-container matColumnDef="memberName" sticky>
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="mobile ? 115 : 155">
                    Member
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="mobile ? 115 : 155" [innerHTML]="element.memberName"></td>
                </ng-container>

                <ng-container matColumnDef="caseNumber" [sticky]="!mobile">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="this.ltssDashboardSwitch ? 107 : 140">
                    Case Number
                  </th>
                  <td mat-cell *matCellDef="let element" [style.borderRight]="'1px solid #bbbbbb3b !important'"
                    [style.width.px]="this.ltssDashboardSwitch ? 107 : 140">
                    {{ element.caseNumber }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="caseStatus">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="this.ltssDashboardSwitch ? 135 : 150">
                    Case Status
                    <span matTooltipClass="my-tooltip" [matTooltip]="caseStatusTooTip"><img [src]="
                          'assets/images/Icons/icons-information-circle-outline.svg'
                        " alt="" /></span>
                    <span class="visually-hidden" aria-hidden="false">{{ "INFORMATION_tooltip" | translate }}
                      {{ caseStatusTooTip }}</span>
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="this.ltssDashboardSwitch ? 135 : 150">
                    @if (element.caseStatus) {
                    <span [ngClass]="{
                        badge: true,
                        'badge-approved': element.caseStatus === 'Approved',
                        'badge-pending': element.caseStatus === 'Pending',
                        'badge-terminated': element.caseStatus === 'Terminated'
                      }">{{ element.caseStatus }}</span>
                    }
                  </td>
                </ng-container>

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="this.ltssDashboardSwitch ? 155 : 210">
                    Action Needed
                    <span #toolTipTemplate="matTooltip" matTooltipClass="html-tooltip" [matTooltip]="actionToolTip"><img
                        [src]="
                          'assets/images/Icons/icons-information-circle-outline.svg'
                        " alt="" /></span>
                    <span class="visually-hidden" aria-hidden="false">{{ "INFORMATION_tooltip" | translate }}
                      {{ actionToolTip }}</span>
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="this.ltssDashboardSwitch ? 155 : 210">
                    @if (element.action === 'AI') {
                    <div class="p-0 hover-red">
                      <a tabindex="0" (click)="toTenncare(element, 'AI')"
                        class="btn p-0 hover-red text-start btn-link"><span>{{
                          "WELCOME_MANAGE_UPLOAD_HEADER" | translate
                          }}</span></a>
                    </div>
                    } @if (element.action === 'PR') {
                    <div class="p-0 hover-red">
                      <a tabindex="0" (click)="toTenncare(element, 'PR')"
                        class="btn p-0 hover-red text-start btn-link"><span>Complete Renewal</span></a>
                    </div>
                    } @if (element.action === 'PT') {
                    <div class="p-0 hover-red">
                      <a tabindex="0" (click)="toTenncare(element, 'PT')"
                        class="btn p-0 hover-red text-start btn-link"><span>Complete Questions for Review</span></a>
                    </div>
                    } @if (element.action === 'TC') {
                    <div class="p-0 hover-red">
                      <a tabindex="0" (click)="toTenncare(element, 'TC')"
                        class="btn p-0 hover-red text-start btn-link"><span>View TennCare Connect</span></a>
                    </div>
                    }
                  </td>
                </ng-container>

                <ng-container matColumnDef="dueDate">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="this.ltssDashboardSwitch ? 125 : 120">
                    Due Date
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="this.ltssDashboardSwitch ? 125 : 120">
                    {{ element.dueDate }}
                  </td>
                </ng-container>

                @if(this.ltssDashboardSwitch) {
                <ng-container matColumnDef="latestNotice">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="145">
                    Latest Notice
                    <span #toolTipTemplate="matTooltip" matTooltipClass="html-tooltip"
                      [matTooltip]="latestNoticeToolTip">
                      <img [src]="'assets/images/Icons/icons-information-circle-outline.svg'" alt="" />
                    </span>
                    <span class="visually-hidden" aria-hidden="false">{{ "LATEST_NOTICE_TOOTLTIP" | translate }}
                      {{ latestNoticeToolTip }}
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="122">
                    @if (element.latestNotice !== null && element.latestNotice !== 'In Progress') {
                    <div class="p-0 hover-red">
                      <a tabindex="0" (click)="toTenncareMyLetters(element)"
                        class="btn p-0 hover-red text-start btn-link"><span>{{ element.latestNotice }}</span></a>
                    </div>
                    }
                    @if (element.latestNotice === 'In Progress') {
                    {{ element.latestNotice }}
                    }
                  </td>
                </ng-container>
                }

                <ng-container matColumnDef="lastAction">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="130">
                    Last Action
                    <span #toolTipTemplate="matTooltip" matTooltipClass="html-tooltip"
                      [matTooltip]="lastActionToolTip"><img [src]="
                          'assets/images/Icons/icons-information-circle-outline.svg'
                        " alt="" /></span>
                    <span class="visually-hidden" aria-hidden="false">{{ "INFORMATION_tooltip" | translate }}
                      {{ lastActionToolTip }}</span>
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="130">
                    {{ element.lastAction }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="remove" [stickyEnd]="!mobile">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="this.ltssDashboardSwitch ? 48 : 110">
                      @if (this.ltssDashboardSwitch) {
                      <span class="visually-hidden">Remove</span>
                      } @else {
                      Remove
                      }
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="this.ltssDashboardSwitch ? 100 : 110">
                    <button type="button" class="remove-member-btn" (click)="removeRecord(element)"
                      [attr.aria-label]="'Remove member with case number ' + element.caseNumber">
                        <nh-remove-svg id="mobile_count" aria-hidden="true"></nh-remove-svg>
                    </button>
                  </td>
                </ng-container>

                <ng-container matColumnDef="indivId">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="120">
                    Client ID
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="120">
                    {{ element.indivId }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="age">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="120">
                    Client Age
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="120">
                    {{ element.age }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="activityType">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="120">
                    Activity Type
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="120">
                    {{ element.activityType }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="renewalDate">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="120">
                    Renewal Date
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="120">
                    {{ element.renewalDate }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="countyCode">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="120">
                    County Code
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="120">
                    {{ element.countyCode }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="countyName">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="120">
                    County Name
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="120">
                    {{ element.countyName }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="coeCode">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="120">
                    COE Code
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="120">
                    {{ element.coeCode }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="coeDescription">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="120">
                    COE Description
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="120">
                    {{ element.coeDescription }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="120">
                    Status
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="120">
                    {{ element.status }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="mcoName">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="120">
                    MCO Name
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="120">
                    {{ element.mcoName }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="homePhoneNumber">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="120">
                    Home Phone Number
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="120">
                    {{ element.homePhoneNumber | phone }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="cellPhoneNumber">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="120">
                    Cell Phone Number
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="120">
                    {{ element.cellPhoneNumber | phone }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="workPhoneNumber">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="120">
                    Work Phone Number
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="120">
                    {{ element.workPhoneNumber | phone }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="aiRequestDate">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="120">
                    AI Request Date
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="120">
                    {{ element.aiRequestDate }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="aiDueDate">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="120">
                    AI Due Date
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="120">
                    {{ element.aiDueDate }}
                  </td>

                  <ng-container matColumnDef="aiRequested">
                    <th mat-header-cell *matHeaderCellDef [style.width.px]="120">
                      AI Requested
                    </th>
                    <td mat-cell *matCellDef="let element" [style.width.px]="120">
                      {{ element.aiRequested }}
                    </td>
                  </ng-container>
                </ng-container>

                <ng-container matColumnDef="lastNoticeSpecialNotes">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="180">
                    Last Notice Special Notes
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="180">
                    @if (element.lastNoticeSpecialNotes) {
                    <div class="large-data-cell">
                      {{ element.lastNoticeSpecialNotes | slice: 0:20 }}
                      <span class="three-dots" tabindex="0" (click)="
                          openLargeData(element.lastNoticeSpecialNotes, $event)
                        ">
                        &#x2026;
                      </span>
                    </div>
                    }
                  </td>
                </ng-container>

                <ng-container matColumnDef="levelOfCare">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="120">
                    Level Of Care
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="120">
                    {{ element.levelOfCare }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="levelOfCareDate">
                  <th mat-header-cell *matHeaderCellDef [style.width.px]="120">
                    Level of Care Date
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width.px]="120">
                    {{ element.levelOfCareDate }}
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </div>

            @if (this.totalResults.length > 7) {
            <div class="custom-pagination">
              <button (click)="changePage(1)" [disabled]="currentPageMat === 1"
                [ngClass]="{ 'next-page': currentPageMat !== 1 }" aria-label="Go to first page">
                &lt;&lt;
              </button>
              <button (click)="changePage(currentPageMat - 1)" [disabled]="currentPageMat === 1"
                [ngClass]="{ 'next-page': currentPageMat !== 1 }" aria-label="Go to previous page">
                &lt;
              </button>
              @for (page of pages; track page) {
              <button (click)="changePage(page)" [ngClass]="{ 'active-page': page === currentPageMat }">
                <span class="page_num">{{ page }}</span>
              </button>
              }
              <button (click)="changePage(currentPageMat + 1)" [disabled]="currentPageMat === total"
                [ngClass]="{ 'next-page': currentPageMat !== total }" aria-label="Go to next page">
                >
              </button>
              <button (click)="changePage(total)" [disabled]="currentPageMat === total"
                [ngClass]="{ 'next-page': currentPageMat !== total }" aria-label="Go to last page">
                >>
              </button>
            </div>

            } @if (this.totalResults.length
            <= 7) { <br />
            }

            <div class="d-flex">
              <button class="btn btn-sm btn-secondary mb-1 edit" (click)="addAnotherMember()">
                Add Another Member
                <svg id="_icons_add-circle-outline" data-name="⚛️ icons/add-circle-outline"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <path id="Combined_Shape" data-name="Combined Shape"
                    d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75ZM9,13.514V10.5H6A.75.75,0,0,1,5.985,9H9V6a.75.75,0,0,1,1.5-.015V9h3a.75.75,0,0,1,.014,1.5H10.5v3a.75.75,0,0,1-1.5.014Z"
                    transform="translate(2.25 2.25)" fill="#174a7c" />
                </svg>
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>